import { Record, Literal, String, Static } from "runtypes";

export const SenderId = String.withConstraint((_) => _.length <= 11).withBrand("SenderId");

export type SenderId = Static<typeof SenderId>;
